module.exports = __webpack_public_path__ + "res/Roboto-Regular-webfont.woff?96948ea3c82150c4843ee2010c7dd7ca";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Regular-webfont.woff
// module id = 18
// module chunks = 0